import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "w-full text-main-100 text-sm"
};
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-2 bg-main-5 py-2 pl-4 pr-2 rounded shadow-weak_material"
};
const _hoisted_3 = {
  key: 0,
  class: "contents"
};
const _hoisted_4 = {
  class: "shrink-0 text-xs"
};
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = {
  class: "h-14 group relative w-full flex items-center gap-3 py-2 px-4"
};
const _hoisted_7 = {
  key: 0,
  class: "flex items-center gap-2 opacity-90"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  key: 1,
  class: "icon-upload text-xl text-second-100"
};
const _hoisted_10 = {
  class: "w-full text-start"
};
const _hoisted_11 = {
  key: 0,
  class: "w-full"
};
const _hoisted_12 = ["title"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["multiple", "accept", "webkitdirectory"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button");
  const _component_InfoComponent = _resolveComponent("InfoComponent");
  return _openBlock(), _createElementBlock(_Fragment, null, [!$options.containsSlot ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$props.directory ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$props.hintText ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.translate($props.hintText)), 1), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "h-6 w-px bg-main-50 shrink-0"
  }, null, -1))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("input", {
    type: "text",
    class: "h-full w-full border-none bg-transparent outline-none placeholder:text-main-50",
    placeholder: _ctx.translate(_ctx.placeholder || 'general.folderpath'),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.value[0] = $event),
    spellcheck: "false"
  }, null, 8, _hoisted_5), [[_vModelText, _ctx.value[0]]]), _createVNode(_component_Button, {
    variant: "outlined",
    size: "xs",
    text: _ctx.translate('general.browse'),
    icon: "icon-folder",
    reversed: true,
    onClick: _cache[1] || (_cache[1] = $event => $options.OpenDialogFolderSelector())
  }, null, 8, ["text"])])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["relative w-full bg-main-5 hover:bg-main-10 hover:shadow-material border border-second-100 text-center rounded transition-[background_box-shadow] duration-300 cursor-pointer", {
      'border-dashed': !_ctx.value?.length,
      'ring-2 ring-blue-400 ring-offset-2': this.globalDragging
    }]),
    onClick: _cache[3] || (_cache[3] = (...args) => $options.EventManager && $options.EventManager(...args)),
    onDrop: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.OnDrop && $options.OnDrop(...args), ["prevent"])),
    onDragover: _cache[5] || (_cache[5] = _withModifiers((...args) => $options.OnDragOver && $options.OnDragOver(...args), ["prevent"]))
  }, [_createElementVNode("div", _hoisted_6, [$options.fileExtensionIcons?.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.fileExtensionIcons, ext => {
    return _openBlock(), _createElementBlock("div", {
      class: "h-7 shrink-0",
      key: ext
    }, [ext ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: ext,
      class: "h-full",
      alt: ""
    }, null, 8, _hoisted_8)) : _createCommentVNode("", true)]);
  }), 128))])) : (_openBlock(), _createElementBlock("i", _hoisted_9)), _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.translate($props.hintText)), 1), _ctx.icon ? (_openBlock(), _createElementBlock("i", {
    key: 2,
    class: _normalizeClass(_ctx.icon)
  }, null, 2)) : _createCommentVNode("", true)]), $props.showFiles ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.selectedFiles, (file, index) => {
    return _openBlock(), _createElementBlock("div", {
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
      key: file,
      class: "h-9 w-full flex items-center justify-between gap-2 bg-second-10 px-3 border-t border-second-100"
    }, [_createElementVNode("p", {
      class: "text-xs truncate",
      title: file.name
    }, _toDisplayString(file.name), 9, _hoisted_12), _createElementVNode("i", {
      class: "icon-cross text-2xs cursor-pointer button-hover",
      onClick: $event => $options.RemoveFile(index)
    }, null, 8, _hoisted_13)]);
  }), 128))])) : _createCommentVNode("", true)], 34))])) : _createCommentVNode("", true), $options.node ? (_openBlock(), _createBlock(_resolveDynamicComponent($options.node), {
    key: 1
  })) : _createCommentVNode("", true), _createElementVNode("input", {
    type: "file",
    class: "hidden",
    ref: "input-element-ref",
    multiple: _ctx.multiple,
    accept: $options.normalizedAccept.toString(),
    webkitdirectory: $props.directories,
    onChange: _cache[6] || (_cache[6] = $event => {
      $options.OnFilesSelect($event.currentTarget.files);
      $event.currentTarget.value = '';
    })
  }, null, 40, _hoisted_14), _createVNode(_component_InfoComponent, {
    data: _ctx.validationStatus
  }, null, 8, ["data"]), this.globalDragging && this.globalDragAndDrop ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    onClick: _cache[7] || (_cache[7] = $event => this.globalDragging = false),
    class: "fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black/30 backdrop-blur-sm text-white"
  }, _cache[9] || (_cache[9] = [_createStaticVNode("<div class=\"absolute top-10 left-10 w-24 h-24 border-t-4 border-l-4 border-white rounded-tl-2xl\"></div><div class=\"absolute top-10 right-10 w-24 h-24 border-t-4 border-r-4 border-white rounded-tr-2xl\"></div><div class=\"absolute bottom-10 left-10 w-24 h-24 border-b-4 border-l-4 border-white rounded-bl-2xl\"></div><div class=\"absolute bottom-10 right-10 w-24 h-24 border-b-4 border-r-4 border-white rounded-br-2xl\"></div><div class=\"flex flex-col items-center\"><i class=\"icon-upload text-5xl mb-4 opacity-70\"></i><p class=\"text-xl font-semibold\">Suelta tus archivos o carpetas aquí</p></div>", 5)]))) : _createCommentVNode("", true)], 64);
}